import { GeofencePointDto } from "../../models/requests/geofence-point-dto";

export type GeofenceMapMode = "geofence" | "tracking";

/**
 * DrawingManager foi deprecado em ago/2025 e removido da Maps JS API em mai/2026
 * (v3.65+). Não use `google.maps.drawing` — desenhe com clique + Polygon/Marker.
 * @see https://developers.google.com/maps/deprecations
 */
export function isGoogleDrawingManagerAvailable(
    googleNs?: { maps?: { drawing?: { DrawingManager?: unknown } } }
): boolean {
    return typeof googleNs?.maps?.drawing?.DrawingManager === "function";
}

export function resolveGeofenceMapClick(args: {
    mode: GeofenceMapMode;
    isDrawing: boolean;
    readOnly: boolean;
    latLng?: { lat: () => number; lng: () => number } | null;
}): { lat: number; lng: number } | null {
    if (args.mode !== "geofence" || !args.isDrawing || args.readOnly || !args.latLng) {
        return null;
    }
    return { lat: args.latLng.lat(), lng: args.latLng.lng() };
}

export function appendGeofenceClickPoint(
    points: GeofencePointDto[],
    latitude: number,
    longitude: number,
    createdAt: Date = new Date()
): GeofencePointDto[] {
    return [
        ...points,
        {
            id: "",
            geofenceId: points[0]?.geofenceId || "",
            index: points.length,
            latitude,
            longitude,
            isActive: true,
            createdAt,
        },
    ];
}

export function removeLastGeofencePoint(points: GeofencePointDto[]): GeofencePointDto[] {
    return points.slice(0, -1).map((point, index) => ({ ...point, index }));
}

/** Pesquisa, pan/zoom do usuário ou modo desenho não podem recentralizar o mapa. */
export function shouldRecenterGeofenceMapViewport(args: {
    hasUserMovedView: boolean;
    isDrawing: boolean;
}): boolean {
    return !args.hasUserMovedView && !args.isDrawing;
}
